import React, { useEffect, useState } from 'react';
import PageHeaderText from 'components/base/page-header-text';

import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';
import AccessDenied from 'components/access-denied';
import useDashboardContext from 'contexts/dashboard.context';

const Trash = () => {
  const [active, setActive] = useState('');
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { permissions } = useDashboardContext();

  useEffect(() => {
    const lastSlashIndex = pathname.lastIndexOf('/');
    let sub_url;
    if (lastSlashIndex !== -1) {
      sub_url = pathname.substring(lastSlashIndex + 1);
      setActive(sub_url);
    }
    if (sub_url === 'trash') {
      navigate(ROUTE_KEYS.TRASH_BRAND);
    }
  }, [pathname]);

  const list = [
    { name: 'Brands', value: 'brands', url: ROUTE_KEYS.TRASH_BRAND },
    { name: 'Meal Categories', value: 'meal_category', url: ROUTE_KEYS.TRASH_MEAL_CATEGORY },
    { name: 'Meals', value: 'meal', url: ROUTE_KEYS.TRASH_MEAL },
    { name: 'Add-on categories', value: 'addon_category', url: ROUTE_KEYS.TRASH_ADDON_CATEGORY },
    { name: 'Add-ons', value: 'addon', url: ROUTE_KEYS.TRASH_ADDON }
  ];

  const canAccessTrash = permissions.canAccessTrash;
  if (!canAccessTrash) return <AccessDenied />;
  return (
    <div>
      <PageHeaderText title='Trash' description='Manage archived/deleted items' />
      <div className='flex gap-5 justify-start border-b-[0.7px] border-b-[#EAEBEB] mb-10'>
        {list.map((item, index) => (
          <Link
            to={item.url}
            className={`py-2 ${
              active === item.url ? 'border-b-[3px]  border-b-[#E60A2B]' : ''
            }  text-[#858585] text-normal cursor-pointer`}
            key={index}>
            {item.name}
          </Link>
        ))}
      </div>
      <Outlet />
    </div>
  );
};

export default Trash;
